import { NgModule } from '@angular/core';
import { ProgressBarComponent } from './progress-bar.component';
import { CommonModule } from '@angular/common';


@NgModule({
    imports: [
        CommonModule
    ],
    exports: [ProgressBarComponent],
    declarations: [ProgressBarComponent],
    providers: [],
})
export class ProgressBarModule { }
